import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, set } from "firebase/database";

const DEFAULT_SETTINGS = {
  appName: "Allô Driver",
  CompanyName: "ALLO DRIVER (SARWA)",
  CompanyAddress: "SARWA, BOITE AUX LETTRES 21 53 AVENUE GAMBETTA 82000 MONTAUBAN",
  CompanyPhone: "+33 6 64 68 00 61",
  CompanyWebsite: "https://allodriver.com",
  CompanyTermCondition: "https://allodriver.com/legal-notice",
  CompanyTerms: "https://allodriver.com/legal-notice",
  CompanySiren: "890 515 737",
  CompanySiret: "890 515 737 00041",
  CompanyVat: "FR92 890 515 737",
  CompanyLegalForm: "SAS, société par actions simplifiée",
  CompanyNaf: "63.12Z - Portails Internet",
  CompanyNaf2025: "62.10Y - Activités de programmation informatique",
  contact_email: "contact@allôdriver.com",
  symbol: "€",
  code: "EUR",
  country: "France",
  restrictCountry: "FR",
  decimal: 2,
  swipe_symbol: false,
  driverRadius: 10,
  convert_to_mile: false,
  useDistanceMatrix: false,
  horizontal_view: false,
  autoDispatch: true,
  emailLogin: true,
  mobileLogin: false,
  socialLogin: true,
  AppleLoginEnabled: true,
  FacebookLoginEnabled: true,
  CarHornRepeat: true,
  showLiveRoute: true,
  panic: "17",
  features: {
    eatEnabled: true,
    eatRestaurantPortalEnabled: true,
    eatCourierEnabled: true
  }
};

const withDefaultSettings = (settings = {}) => ({
  ...DEFAULT_SETTINGS,
  ...settings,
  features: {
    ...DEFAULT_SETTINGS.features,
    ...(settings.features || {})
  }
});

export const fetchSettings= () => (dispatch) => {

  const {
    settingsRef
  } = firebase;

  // Check if database is available
  if (!settingsRef) {
    console.warn("Database not available, using default settings");
    // Provide minimal default settings to allow app to continue
    const defaultSettings = withDefaultSettings();
    
    dispatch({
      type: FETCH_SETTINGS_SUCCESS,
      payload: defaultSettings
    });
    return;
  }

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });
  
  // Set a timeout to provide default settings if Firebase doesn't respond
  const timeoutId = setTimeout(() => {
    const defaultSettings = withDefaultSettings();
    
    dispatch({
      type: FETCH_SETTINGS_SUCCESS,
      payload: defaultSettings
    });
  }, 3000); // 3 second timeout
  
  onValue(settingsRef, (snapshot) => {
    clearTimeout(timeoutId); // Cancel timeout if Firebase responds
    if (snapshot.val()) {
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: withDefaultSettings(snapshot.val()),
      });
    } else {
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: "Unable to fetch database and settings.",
      });
    }
  });
};

export const editSettings = (settings) => (dispatch) => {
  const {
    settingsRef
  } = firebase;
  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });
  set(settingsRef, settings);
  alert(store.getState().languagedata.defaultLanguage.updated);
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};